import { useApiClient } from '../../api/useApiClient';

/**
 * Servicio para operaciones relacionadas con API Keys
 */
class ApiKeyService {
    constructor(apiClient) {
        this.apiClient = apiClient;
    }

    /**
     * Crear una nueva API Key para el usuario autenticado
     * @param {Object} data - Datos de la API Key { description, expirationDays }
     * @returns {Promise} Response con la API Key generada
     */
    async createApiKey(data) {
        return this.apiClient.post('/api/v1/api-keys', data);
    }

    /**
     * Listar las API Keys del usuario autenticado
     * @returns {Promise} Response con lista de API Keys
     */
    async listMyApiKeys() {
        return this.apiClient.get('/api/v1/api-keys');
    }

    /**
     * Revocar una API Key
     * @param {number} keyId - ID de la API Key a revocar
     * @returns {Promise} Response
     */
    async revokeApiKey(keyId) {
        return this.apiClient.delete(`/api/v1/api-keys/${keyId}`);
    }

    /**
     * Revocar cualquier API Key (ADMIN, sin chequeo de ownership)
     * @param {number} keyId - ID de la API Key a revocar
     * @returns {Promise} Response
     */
    async revokeApiKeyAdmin(keyId) {
        return this.apiClient.delete(`/api/v1/admin/api-keys/${keyId}`);
    }

    /**
     * Listar todas las API Keys (ADMIN)
     * @returns {Promise} Response con lista de todas las API Keys
     */
    async listAllApiKeys() {
        return this.apiClient.get('/api/v1/admin/api-keys');
    }

    /**
     * Crear una API Key para cualquier usuario (ADMIN)
     * @param {Object} data - Datos de la API Key { userId, description, expirationDays }
     * @returns {Promise} Response con la API Key generada
     */
    async createApiKeyForUser(data) {
        return this.apiClient.post('/api/v1/admin/api-keys', data);
    }
}

/**
 * Hook personalizado para usar el servicio de API Keys
 * @returns {ApiKeyService} Instancia del servicio
 */
export const useApiKeyService = () => {
    const apiClient = useApiClient();
    return new ApiKeyService(apiClient);
};

export default ApiKeyService;
